import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { PromotorCategoryAssignmentModel } from 'src/app/model/promotor-category-assignment.model';
import { PromotorCategoryAssignmentService } from 'src/app/services/promotor-category-assignment.service';

@Component({
  selector: 'app-modal-promotor-category-assignment',
  templateUrl: './modal-promotor-category-assignment.component.html',
  styleUrls: ['./modal-promotor-category-assignment.component.css']
})
export class ModalPromotorCategoryAssignmentComponent implements OnInit {
  @Input() entity: PromotorCategoryAssignmentModel;
  @Input() mode: string;
  @Input() employees: any[] = [];
  @Input() categories: any[] = [];

  public viewStatus = 1;

  public customPatterns = {
    'A': { pattern: new RegExp('[a-zA-Z0-9ñÑ ]') },
    'C': { pattern: new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]') }
  };

  constructor(
    private assignmentService: PromotorCategoryAssignmentService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  ngOnInit() { }

  toggleActive = () => this.entity.activeId = !this.entity.activeId;

  isValid = () => {
    let valid = true;
    let errors = [];

    if (!this.entity.employeeId) errors.push('Seleccione un empleado.');
    if (!this.entity.promoterCategoryId) errors.push('Seleccione una categoría de promotor.');
    if (!this.entity.assignmentStartDate) errors.push('Ingrese la fecha de inicio.');

    // Validar que fecha fin sea mayor o igual a fecha inicio (si existe)
    if (this.entity.assignmentEndDate && this.entity.assignmentStartDate) {
      const startDate = new Date(this.entity.assignmentStartDate);
      const endDate = new Date(this.entity.assignmentEndDate);
      if (endDate < startDate) {
        errors.push('La fecha de fin debe ser mayor o igual a la fecha de inicio.');
      }
    }

    // Validar longitud de razón
    if (this.entity.assignmentReason && this.entity.assignmentReason.length > 500) {
      errors.push('La razón de asignación no puede exceder 500 caracteres.');
    }

    if (errors.length > 0) {
      valid = false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', { enableHtml: true });
    }
    return valid;
  }

  save = () => {
    if (this.isValid()) {
      this.viewStatus = 0;

      // Establecer modifUserId al editar
      if (this.mode === 'edit') {
        this.entity.modifUserId = Number(localStorage.getItem('com_token'));
      }

      // Usar update o save según el modo
      const service$ = this.mode === 'edit'
        ? this.assignmentService.update(this.entity)
        : this.assignmentService.save(this.entity);

      service$
        .pipe(
          tap((resp: any) => {
            if (resp && resp.codeHttpStatus === 200) {
              this.modalService.dismissAll('success');
              this.toastr.success('La asignación se guardó con éxito.');
            } else {
              this.viewStatus = 1;
              this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar guardar la asignación.');
            }
          }),
          catchError(error => {
            this.viewStatus = 1;
            return of(this.toastr.error('Ocurrió un error al intentar guardar la asignación.'));
          })
        )
        .subscribe();
    }
  }

  close = () => this.modalService.dismissAll();
}
